<template>
  <div id="optOutSubmitted">
    <el-card
      shadow="hover"
      :style="{width: '50%'}"
    >
      <el-row
        type="flex"
        :gutter="2"
      >
        <el-col
          :span="responsiveCol.one"
          class="colLogo"
        >
          <i class="icon el-icon-circle-check"></i>
        </el-col>
        <el-col
          :span="responsiveCol.two"
          class="colContent"
        >
          <div class="content">
            {{ $t('coworker.optOut.optedOut') }}
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  computed: {
    responsiveCol() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
        col.two = 24;
      } else {
        col.one = 4;
        col.two = 20;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
#optOutSubmitted {
  .el-card {
    margin: 0 auto;

    .icon {
      font-size: 70px;
      color: #29abe2;
    }

    .el-row {
      flex-wrap: wrap;

      .el-col {
        justify-content: center;
        align-self: center;

        &.colLogo {
          text-align: center;
          padding: 20px 0;
        }

        &.colContent {
          padding: 15px;
        }
      }
    }
  }
}
</style>
